module.exports = __webpack_public_path__ + "img/job-data.136c0d21.png";